import axiosInstance from "./axiosInstance";

const getOffer = async (dateFrom, dateTo, roomType) => {
  return await axiosInstance
    .get(
      `${process.env.REACT_APP_BASE_URL}/reservatio-obtenerOfertas?date_from=${dateFrom}&date_to=${dateTo}&room_type=${roomType}`,
      {
        withCredentials: true,
      }
    )
    // .get(
    //   `${process.env.REACT_APP_RESERVATIO_URL}/available_offers?date_from=${dateFrom}&date_to=${dateTo}&room_type=${roomType}`,
    //   {
    //     headers: {
    //       Token: process.env.REACT_APP_RESERVATIO_TOKEN,
    //     },
    //   }
    // )
    .then((res) => res)
    .catch((err) => err);
};

export default getOffer;
